import script from "./productDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./productDetails.vue?vue&type=script&lang=ts&setup=true"

import "./productDetails.vue?vue&type=style&index=0&id=76a3e120&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76a3e120"]])

export default __exports__